/* modules/profile/cards/ChangePasswordCard/index.js */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { upperFirst } from 'lodash';

import { withStyles } from '@material-ui/core/styles';

import {
  Button,
  Checkbox,
  Paper,
  Table, TableBody, TableCell, TableHead, TableRow,
  Typography,
} from '@material-ui/core';
import { PaperHeader } from '../../../../app/components';

import styles from './styles';
import { loadTexts } from '../../../../config/texts';

import { updateNotificationPreference } from '../../actions';
const TEXT_KEY = "profile";

class NotificationPreferenceCard extends React.Component {
  constructor(props) {
    super(props);
    this.texts = loadTexts(TEXT_KEY, props.locale);
    this.preferenceList = [
      { type: 'CS_MESSAGE', title: this.texts.preference.message, },
      { type: 'REVIEW_GIVEN', title: this.texts.preference.all_review },
      { type: 'LT4_REVIEWS', title: this.texts.preference.four_star_review },
      { type: 'PAYMENT_DECLINE', title: this.texts.preference.payment_failed },
      { type: 'USER_SIGNUP', title: this.texts.preference.student_signup },
      { type: 'LESSON_COMPLETED', title: this.texts.preference.lesson_complete },
      { type: 'LESSON_CANCELATION', title: this.texts.preference.lesson_cancelled },
      { type: 'LESSON_DECLINE', title: this.texts.preference.lesson_declined },
      { type: 'LESSON_OVERPENDING', title: this.texts.preference.over_pending },
      { type: 'COURSE_REQUEST', title: this.texts.preference.course_request },
      { type: 'COURSE_APPROVAL_REQUEST', title: this.texts.preference.course_approval },
      { type: 'PRIVATE_LOCATION_REQUEST', title: this.texts.preference.location_request },
    ];
    this.headers = [this.texts.header.event, this.texts.header.receive];
    const { preference } = props;
    const initial = this.preferenceList.reduce((acc, x) => {
      const { email, notification } = preference.find(p => p.type === x.type)
        || { email: false, notification: false };
      return { ...acc, [x.type]: { email, notification } };
    }, {});
    this.state = {
      initial,
      current: JSON.parse(JSON.stringify(initial)),
    }
  }

  onSubmit = async event => {
    event.preventDefault();
    const { initial, current } = this.state;
    const input = Object.keys(initial).map(type => {
      const { notification, email } = current[type];
      return { type, notification, email };
    });
    await this.props.updateNotificationPreference({
      notificationPreferenceInput: input,
    });
    this.setState({ initial: JSON.parse(JSON.stringify(this.state.current)) });
  };

  onChangeCheckbox = (eventType, type) => {
    this.setState(prevState => ({ current: { ...prevState.current, [eventType]: {
      ...prevState.current[eventType],
      [type]: !prevState.current[eventType][type],
    }} }));
  }

  onCancel = () => {
    this.setState({ current: JSON.parse(JSON.stringify(this.state.initial )) });
  };

  renderCheckbox = (eventType, type, checked) => (
    <React.Fragment>
      <Checkbox
        checked={checked}
        onChange={() => this.onChangeCheckbox(eventType, type)}
        color="primary"
        value={`${eventType}-${type}-${checked}`}
      />
      <Typography className={this.props.classes.checkboxLabel}>
        {type === 'email' ? this.texts.email : this.texts.notification}
      </Typography>
    </React.Fragment>
  )

  render() {
    const { classes, preference } = this.props;
    const { initial, current } = this.state;
    const changed = Object.keys(initial).reduce((acc, x) => {
      if (acc) return true;
      const c = current[x];
      const i = initial[x];
      return c.email !== i.email || c.notification !== i.notification;
    }, false);
    return (
      <Paper>
        <PaperHeader text={this.texts.header.preference} />
        <Typography className={classes.subtitle}>
          {this.texts.title}
        </Typography>
        <form onSubmit={this.onSubmit}>
          <Table>
            <TableHead>
              <TableRow>
                {this.headers.map(h => (
                  <TableCell key={h} padding="dense">
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.preferenceList.map(p => {
                const { notification, email } = current[p.type];
                return (
                  <TableRow key={p.type}>
                    <TableCell>
                      {p.title}
                    </TableCell>
                    <TableCell className={classes.checkboxCell}>
                      {this.renderCheckbox(p.type, 'notification', notification)}
                      {this.renderCheckbox(p.type, 'email', email)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <div className={classes.buttonContainer}>
            <Button variant="contained" disabled={!changed} onClick={this.onCancel}>
              {this.texts.button_text.cancel}
            </Button>
            <Button
              className={classes.saveButton}
              variant="contained"
              type="submit"
              disabled={!changed}
              color="primary"
            >
              {this.texts.button_text.save}
            </Button>
          </div>
        </form>
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  preference: state.auth.data.user.notificationPreference,
  locale: state.appState.locale
});

const mapDispatchToProps = dispatch => ({
  updateNotificationPreference: params => dispatch(updateNotificationPreference(params)())
});

export default compose(
  withStyles(styles, { name: 'NotificationPreferenceCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(NotificationPreferenceCard);



// WEBPACK FOOTER //
// ./src/modules/profile/cards/NotificationPreferenceCard/index.js